var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeader"},[_c('el-page-header',{attrs:{"content":_vm.title},on:{"back":_vm.goBack}}),_c('div',{staticClass:"controls"},[_vm._t("controls")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }